/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VisibilityEnum } from './visibility-enum';
import { DeckPitchDetailLimitPaymentOptionsTo } from './deck-pitch-detail-limit-payment-options-to';
import { DealflowFile } from './dealflow-file';
import { Label } from './label';
import { DeckCompany } from './deck-company';
import { DeckInvestmentsExportSimple } from './deck-investments-export-simple';

export interface DeckPitchDetail {
  readonly id: string;
  readonly name: string;
  readonly company: DeckCompany;
  readonly total_raised: number;
  readonly number_of_investors: number;
  readonly min_goal: string | null;
  readonly max_goal: string | null;
  /**
   * Pitches are closed every half hour
   */
  readonly end_day: string | null;
  /**
   * public - visible for every user; unlisted - accessible only from direct link; private - visible only for admins; coming up - visible but not accessible;draft -
   */
  readonly visibility: VisibilityEnum;
  readonly share_price: string | null;
  readonly featured: boolean;
  readonly first_end_date: string | null;
  readonly start_date: string | null;
  readonly labels: Array<Label>;
  readonly homepage: string | null;
  readonly tax_deducted: boolean | null;
  readonly dealflow_files: Array<DealflowFile>;
  readonly general_meeting_date: string | null;
  readonly number_of_invitations: number;
  readonly payment_due: string | null;
  readonly threshold_value: string | null;
  readonly investment_step: string | null;
  readonly investments_exports: Array<DeckInvestmentsExportSimple>;
  limit_payment_options_to: DeckPitchDetailLimitPaymentOptionsTo | null;
  readonly max_per_investor: string | null;
  readonly min_per_investor: string | null;
  readonly require_vps: boolean;
  readonly account_number: string;
  readonly short_description: string;
  /**
   * banner used with pitch
   */
  readonly banner: string;
  readonly photo: string | null;
  readonly seo_image: string;
  readonly pre_money_eval: string | null;
}
export namespace DeckPitchDetail {}
